export const calculateFitnessLevel = (xp: number): number => {
  if (xp < 100) return 1;

  let level = 1;
  let xpNeeded = 100;
  let totalXp = 0;

  while (totalXp + xpNeeded <= xp) {
    totalXp += xpNeeded;
    level++;
    xpNeeded = Math.floor(xpNeeded * 1.15);
  }

  return level;
};

export const calculateXpForLevel = (level: number): number => {
  if (level <= 1) return 0;

  let totalXp = 0;
  let xpNeeded = 100;

  for (let i = 1; i < level; i++) {
    totalXp += xpNeeded;
    xpNeeded = Math.floor(xpNeeded * 1.15);
  }

  return totalXp;
};

export const calculateXpToNextLevel = (currentXp: number): number => {
  const currentLevel = calculateFitnessLevel(currentXp);
  const xpForCurrentLevel = calculateXpForLevel(currentLevel);
  const xpForNextLevel = calculateXpForLevel(currentLevel + 1);

  return xpForNextLevel - currentXp;
};

export const calculateCurrentLevelXp = (currentXp: number): number => {
  const currentLevel = calculateFitnessLevel(currentXp);
  const xpForCurrentLevel = calculateXpForLevel(currentLevel);

  return currentXp - xpForCurrentLevel;
};

export const calculateLevelProgress = (currentXp: number): number => {
  const currentLevel = calculateFitnessLevel(currentXp);
  const xpForCurrentLevel = calculateXpForLevel(currentLevel);
  const xpForNextLevel = calculateXpForLevel(currentLevel + 1);

  const xpInCurrentLevel = currentXp - xpForCurrentLevel;
  const xpNeededForLevel = xpForNextLevel - xpForCurrentLevel;

  return Math.min((xpInCurrentLevel / xpNeededForLevel) * 100, 100);
};

export const getFitnessRank = (level: number): string => {
  if (level >= 100) return 'Legendary';
  if (level >= 75) return 'Master';
  if (level >= 50) return 'Expert';
  if (level >= 30) return 'Advanced';
  if (level >= 15) return 'Intermediate';
  if (level >= 5) return 'Novice';
  return 'Beginner';
};

export const formatFitnessXP = (xp: number): string => {
  if (xp >= 1000000) {
    return `${(xp / 1000000).toFixed(1)}M`;
  }
  if (xp >= 1000) {
    return `${(xp / 1000).toFixed(1)}K`;
  }
  return xp.toString();
};

export const DEFAULT_FITNESS_XP_GAINS = {
  quick: 10,
  short: 25,
  medium: 50,
  long: 100,
  intense: 150,
  extreme: 250
};
